import { render, staticRenderFns } from "./PeriodTable.vue?vue&type=template&id=2f34c151&scoped=true"
import script from "./PeriodTable.vue?vue&type=script&lang=js"
export * from "./PeriodTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodTable.vue?vue&type=style&index=0&id=2f34c151&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34c151",
  null
  
)

export default component.exports